import { InjectionKey } from "vue";

export const PADDLE_TOKEN = '$paddle';
export const PADDLE_INJECTION_KEY: InjectionKey<any> = Symbol(PADDLE_TOKEN);
